import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { InfoStoreType } from '@/types/store/info-store.type';

const namespaced: boolean = true;
export const info: Module<InfoStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
